import React from 'react';
import PropTypes from 'prop-types';
import { Edit, Delete } from '@material-ui/icons';
import Tooltip from '@material-ui/core/Tooltip';

import IconButton from '@material-ui/core/IconButton';
import { checkPermissions, checkOwnPermissions } from '../../services/authorization-service';
import { useToggleNavBar } from '../../libraries/contexts';

const ActionButtons = props => {
  const { value, service, history, classes, name, getRequests } = props;
  const [toggleValue, changeToggleNavBar] = useToggleNavBar();

  const applyRemoveRequest = async value => {
    await service.delete(value);
  };

  const goToEdition = () => {
    history.push(service.editPage(value));
  };

  const removeElement = async () => {
    const { main, secondary } = toggleValue;

    await applyRemoveRequest(value);
    await getRequests();

    changeToggleNavBar({
      main,
      secondary,
      message: { message: 'Registro eliminado', key: value, service, undo: false, open: true }
    });
  };
  return (
    <div className={classes.actionButton}>
      {checkPermissions([`EDIT_${name}`]) ? (
        <Tooltip title="Editar" placement="top">
          <IconButton disabled={false} onClick={goToEdition} color="primary">
            <Edit />
          </IconButton>
        </Tooltip>
      ) : (
        ''
      )}
      {checkOwnPermissions(value)([`DELETE_${name}`]) ? (
        <Tooltip title="Eliminar" placement="top">
          <IconButton onClick={removeElement} linkButton={true} disabled={false} color="secondary">
            <Delete />
          </IconButton>
        </Tooltip>
      ) : (
        ''
      )}
    </div>
  );
};

ActionButtons.propTypes = {
  classes: PropTypes.object.isRequired
};

export default ActionButtons;
